import StatusLabelReact from 'ui/StatusLabel'
import SpaceReact from 'ui/Space'
import React from 'react'
import roundTo from 'round-to'
import humanizeNumber from 'humanize-number'
import numeral from 'numeral'

export function getStatusLabelReact(status) {
  switch (status) {
    case 'success':
      return React.createElement(StatusLabelReact, {
        status: 'success',
        children: 'Data Flowing'
      })
    case 'success-warning':
      return React.createElement(StatusLabelReact, {
        status: 'warning',
        children: 'Data Flowing'
      })
    case 'success-empty':
      return React.createElement(StatusLabelReact, {
        status: 'success',
        children: 'No New Data'
      })
    case 'empty':
      return React.createElement(StatusLabelReact, {
        status: 'warning',
        children: 'No Data'
      })
    case 'warning':
      return React.createElement(StatusLabelReact, {
        status: 'warning',
        children: 'Warning'
      })
    case 'error':
      return React.createElement(StatusLabelReact, {
        status: 'error',
        children: 'Failed'
      })
    case 'pending':
      return React.createElement(StatusLabelReact, {
        status: 'running',
        children: 'Syncing'
      })
    default:
      return React.createElement(StatusLabelReact, {
        status: 'unknown',
        children: 'Unknown'
      })
  }
}

export function addSpaceReact(size) {
  return (acc, item, i, array) => {
    acc.push(item)
    if (i + 1 !== array.length) {
      acc.push(React.createElement(SpaceReact, { value: size }))
    }
    return acc
  }
}

export function abbreviateNumber(value) {
  if (value >= 1000000000) {
    const num = value / 1000000000
    return `${humanizeNumber(roundTo(num, 1))} B`
  }

  if (value >= 1000000) {
    const num = value / 1000000
    return `${humanizeNumber(roundTo(num, 1))} M`
  }

  if (value >= 1000) {
    const num = value / 1000
    return `${humanizeNumber(roundTo(num, 1))} K`
  }

  return humanizeNumber(value)
}

/* Takes a list of words, i.e. ['apple', 'banana', orange'] and renders
 * it to a grammatically correct sentence partial:
 * 'apple, banana, and orange'
 */

export function joinList(list) {
  const listLength = list.length
  return list.slice(1, listLength).reduce((sentence, word, i) => {
    const isLastCharacter = i === listLength - 2
    const isSecondCharacter = i === 0
    if (isLastCharacter && isSecondCharacter) {
      return `${sentence} and ${word}`
    }
    if (isLastCharacter) {
      return `${sentence}, and ${word}`
    }
    return `${sentence}, ${word}`
  }, list[0])
}

function humanizeUnit(unit) {
  if (unit === 'b') {
    return 'Billion'
  }
  if (unit === 'k') {
    return 'Thousand'
  }
  if (unit === 'm') {
    return 'Million'
  }
  return unit.toUpperCase()
}

export function humanizeNumberWithUnits(number, decimalPoints = 1) {
  if (number < 100000) {
    return humanizeNumber(number)
  }

  const zeroes = new Array(decimalPoints).fill('0').join('')
  const abbreviatedNumber = numeral(number).format(`0.${zeroes}a`)
  const unit = abbreviatedNumber.substring(abbreviatedNumber.length - 1)
  return `${abbreviatedNumber.slice(0, -1)} ${humanizeUnit(unit)}`
}
